import { Injectable } from '@angular/core';
import { DEVICE_SIZE } from '../models/others.model';
import { mediaConfig } from '../../spartacus/features/store-front/default-media.config';
import { CmsBannerComponentMedia, CmsResponsiveBannerComponentMedia, WindowRef } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class ToolsService {
  constructor(private winRef: WindowRef) {}

  stringToBoolean(value: string | null | undefined): boolean {
    return value ? value.toLowerCase() === 'true' || value === '1' : false;
  }

  getSizeScreen() {
    return {
      width: this.winRef.isBrowser() ? this.winRef.nativeWindow?.innerWidth || 1920 : 1920,
      height: this.winRef.isBrowser() ? this.winRef.nativeWindow?.innerHeight || 0 : 0,
    };
  }

  getCurrentSize(): DEVICE_SIZE {
    const screenSize = this.getSizeScreen();

    if (screenSize.width >= mediaConfig!.mediaFormats![DEVICE_SIZE.WIDESCREEN.toLocaleLowerCase()]!.width!) {
      return DEVICE_SIZE.WIDESCREEN;
    }

    if (screenSize.width >= mediaConfig!.mediaFormats![DEVICE_SIZE.DESKTOP.toLocaleLowerCase()]!.width!) {
      return DEVICE_SIZE.DESKTOP;
    }

    if (screenSize.width > mediaConfig!.mediaFormats![DEVICE_SIZE.MOBILE.toLocaleLowerCase()]!.width!) {
      return DEVICE_SIZE.TABLET;
    }

    return DEVICE_SIZE.MOBILE;
  }

  getCurrentMediaFormat(medias: CmsResponsiveBannerComponentMedia): CmsBannerComponentMedia {
    const currentSize = this.getCurrentSize();
    let currentFormat: any = undefined;

    if (currentSize === DEVICE_SIZE.MOBILE) {
      currentFormat = medias.mobile ?? medias.tablet ?? medias.desktop ?? medias.widescreen;
    } else if (currentSize === DEVICE_SIZE.TABLET) {
      currentFormat = medias.tablet ?? medias.desktop ?? medias.widescreen ?? medias.mobile;
    } else if (currentSize === DEVICE_SIZE.DESKTOP) {
      currentFormat = medias.desktop ?? medias.widescreen ?? medias.tablet ?? medias.mobile;
    } else {
      currentFormat = medias.widescreen ?? medias.desktop ?? medias.tablet ?? medias.mobile;
    }

    return currentFormat;
  }

  loadExternalScript(scriptURL: string, onLoad: () => void, onError?: () => void) {
    if (this.winRef.isBrowser()) {
      const script = this.winRef.document.createElement('script');
      script.src = scriptURL;

      script.onload = () => {
        onLoad();
      };

      script.onerror = () => {
        // eslint-disable-next-line no-console
        console.error('Cannot Load: ' + scriptURL);
        onError && onError();
      };

      this.winRef.document.body.appendChild(script);
    }
  }
}
